<div #tooltip class="tooltip {{tooltipData.cssClass}}"
     *ngIf="tooltipData.show && tooltipData.message !== ''"
     [style.top]="tooltipData.top + 'px'"
     [style.left]="tooltipData.left + 'px'"
    (mouseout)="closeTooltip();"
     [ngClass]="{'active' : showModal}">{{tooltipData.message}}</div>
